
import {createLoadableList, createLoadableObject} from 'helpers/context'

const standards = {
  expectations: createLoadableList(),
  standards: createLoadableList(),
  subjects: createLoadableList(),
  grades: createLoadableList(),
  assessment: {},
  assessmentIndicators: {},
  assessmentStandards: createLoadableList(),
  selectStandards: {selected: {}, questionStandards: {}},
  standardsSearch: {selected: {}, questionStandards: {}}
}

export {standards as default}
